import type { GameConfig } from './index.js'

/** Defaults shared by staged lobby rules, the editor and the game engine. */
export const DEFAULT_GAME_CONFIG: GameConfig = {
  startingTroops: 4,
  maxAttacksPerTurn: null,
  maxFortifiesPerTurn: 5,
  maxTurns: 500,
  // Skip claiming for the normal mobile opening; hosts can choose manual claim.
  autoAssignTerritories: true,
  eliminatePlayerBonus: 5,
  cardBonusSchedule: 'cycle',
}

/** Undefined means default; null retains its explicit Unlimited meaning. */
export function gameConfigWithDefaults(overrides: Partial<GameConfig> = {}): GameConfig {
  const values = Object.fromEntries(Object.entries(overrides).filter(([, value]) => value !== undefined)) as Partial<GameConfig>
  return { ...DEFAULT_GAME_CONFIG, ...values }
}
